export type UserMsg = {
  title: string;
  msg: string;
  icon?: string;
};

export const USER_MSG = {
  SUCCESS_TOS: {
    title: "Done!",
    msg: "Agreed to Terms of Use.",
  },
  ERROR_INVALID_BUYING_GROUP: {
    title: "A Buying Group Exists",
    msg: "A buying group has already been defined. You are limited to 1 buying group. If you need a new buying group please remove the previously defined buying group and try again.",
    icon: "🚫",
  },
  PROJECTS_NOT_FOUND: {
    title: "No Projects Were Found",
    msg: "Create new project to get started",
  },
  EMPLOYEES_NOT_FOUND: {
    title: "No Employees Were Found",
    msg: "Add a new employee to get started",
  },
  GENERIC_LOADING: {
    title: "Fetching data",
    msg: "Hang tight while we get your data!",
  },
  EMPLOYEES_LOADING: {
    title: "Fetching Employees",
    msg: "Hang tight while we get your employees!",
  },
  DEALER_NOT_FOUND: {
    title: "No Dealer Was Found",
    msg: "Please Contact Latham Admin",
  },
  DEALER_LOADING: {
    title: "Fetching Dealer",
    msg: "Hang tight while we get your dealer!",
  },
  SUCCESS_GENERIC: {
    title: "Done!",
    msg: "Operation Successful",
  },
  SUCCESS_IMAGE: {
    title: "Done!",
    msg: "Resources Uploaded",
  },
  SUCCESS_ORDER_CREATE: {
    title: "Done!",
    msg: "Successfully created order",
  },
  SUCCESS_ORDER_DELETE: {
    title: "Done!",
    msg: "Successfully deleted order",
  },
  SUCCESS_ORDER_SAVE: {
    title: "Done!",
    msg: "Successfully saved order",
  },
  SUCCESS_ORDER_ARCHIVE: {
    title: "Done!",
    msg: "Successfully archived order",
  },
  SUCCESS_ORDER_UNARCHIVE: {
    title: "Done!",
    msg: "Successfully unarchived order",
  },
  SUCCESS_QUOTE_CREATE: {
    title: "Done!",
    msg: "Successfully created quote",
  },
  SUCCESS_QUOTE_SAVE: {
    title: "Done!",
    msg: "Successfully saved quote",
  },
  SUCCESS_SCAN_REJECT: {
    title: "Done!",
    msg: "Successfully rejected scan",
  },
  SUCCESS_SCAN_UNREJECT: {
    title: "Done!",
    msg: "Successfully un-rejected scan",
  },
  SUCCESS_QUOTE_REVERT: {
    title: "Done!",
    msg: "Successfully reverted quote",
  },
  SUCCESS_QUOTE_SUBMIT: {
    title: "Done!",
    msg: "Successfully submitted quote to Latham",
  },
  SUCCESS_QUOTE_CANCEL: {
    title: "Done!",
    msg: "Successfully canceled quote",
  },
  SUCCESS_QUOTE_ARCHIVE: {
    title: "Done!",
    msg: "Successfully archived quote",
  },
  SUCCESS_QUOTE_UNARCHIVE: {
    title: "Done!",
    msg: "Successfully unarchived quote",
  },
  SUCCESS_ORDER_SUBMIT: {
    title: "Done!",
    msg: "Successfully submitted order to Latham",
  },
  ERROR_SCAN_REJECT_EMPTY_REASON: {
    title: "Error",
    msg: "Please provide a reason for rejection",
  },
  ERROR_ORDER_ID_MISSING: {
    title: "Error",
    msg: "No order selected",
  },
  ERROR_SAVING_ORDER: {
    title: "Your order could not be saved!",
    msg: "Something went wrong when saving your order",
  },
  ERROR_CREATING_ORDER: {
    title: "Your order could not be created!",
    msg: "Something went wrong when creating your order",
  },
  ERROR_NEW_QUOTE: {
    title: "You cannot create a new quote!",
    msg: "Please select a pool shape before creating a quote",
  },
  ERROR_DELETING_ORDER: {
    title: "Your order could not be deleted!",
    msg: "Something went wrong when deleting your order",
  },
  ERROR_DELETING_QUOTE: {
    title: "Your quote could not be deleted!",
    msg: "Something went wrong when deleting your order",
  },
  ERROR_SAVING_PROJECT: {
    title: "Your project could not be saved!",
    msg: "Something went wrong when saving your project",
  },
  ERROR_CREATING_PROJECT: {
    title: "Your project could not be created!",
    msg: "Something went wrong when creating your project",
  },
  ERROR_DELETING_PROJECT: {
    title: "Your project could not be deleted!",
    msg: "Something went wrong when deleting your project",
  },
  ERROR_ORDER_DATA: {
    title: "Error Submitting Data to LathamLink",
    msg: "Something went wrong when submitting your data to LathamLink.",
  },
  ERROR_MEASUREMENT_DATA: {
    title: "Missing Data",
    msg: "This project is missing measurement data that is required for a quote. Please upload the project from the iPad that has the measurement.",
  },
  ERROR_GENERIC: {
    title: "Oops",
    msg: "Something went wrong, please try again or refresh",
    icon: "💥",
  },
  ERROR_INVALID: {
    title: "Missing Data",
    msg: "Please complete all required fields",
    icon: "🚫",
  },
  ERROR_EMAIL_CONFLICTS: {
    title: "Email Conflicts",
    msg: "The email address already exists.",
    icon: "🚫",
  },
  ERROR_PROJECT_SCAN_REJECTED: {
    title: "Project Quote Rejected",
    msg: "This quote has been rejected due to insufficient scan data.",
    icon: "🚫",
  },
  ERROR_INVALID_DATA: {
    title: "Invalid data",
    msg: "Please enter valid data!",
    icon: "🚫",
  },
  ERROR_INCOMPLETE_PROJECT: {
    title: "Missing Project Data",
    msg: "Each of the required project fields must be populated. Return to the project details, populate the required fields, then try again.",
    icon: "🚫",
  },
  ERROR_PURCHASE_PARTNER_DEALER_NOT_FOUND: {
    title: "Purchasing Partner Not Found",
    msg: "The selected purchasing partner does not exist in our system. Please contact your administrator for assistance.",
    icon: "🚫",
  },
  ERROR_SAVING_PURCHASE_PARTNER: {
    title: "Purchasing partner could not be assigned",
    msg: "Something went wrong when assigning the purchasing partner",
  },
  ERROR_QUOTE_ORDER_DISABLED_PURCHASE_PARTNER: {
    title: "Quote and Order Actions Disabled",
    msg: "You cannot perform quote or order actions when the project is assigned to a purchase partner.",
    icon: "🚫",
  },
  ERROR_UNAUTH_ROUTE: {
    title: "Unauthorized",
    msg: `Your account is not authorized to access this section. Please contact Latham or use another account.`,
    icon: "🚫",
  },
  ERROR_UNAUTH_LOGIN: {
    title: "Unauthorized",
    msg: `Your account is not authorized to access this site. Please contact Latham or use another account. You will now be redirected to the login page.`,
    icon: "🚫",
  },
  ERROR_PASSWORD_CHANGE_REQUIRED: {
    title: "Password Change Required",
    msg: `Before logging in you must change your password. An email will be sent to you shortly. You will now be redirected to the login page.`,
    icon: "🚫",
  },
  ERROR_PASSWORD_RESET_REQUIRED: {
    title: "Password Change Required",
    msg: `Your password must be reset by an administrator. You will now be redirected to the login page.`,
    icon: "🚫",
  },
  ERROR_UNAUTHORIZED_ACCESS: {
    title: "Unauthorized Access",
    msg: `Your account is not authorized to perform this action. Please contact your administrator for further assistance.`,
    icon: "🚫",
  },
  ERROR_USER_NOT_FOUND: {
    title: "Sorry",
    msg: `Your account is misconfigured. Please contact Latham or use another account. You will now be redirected to the login.`,
    icon: "🔧",
  },
  ERROR_SERVER: {
    title: "Sorry",
    msg: `Our systems are experiencing a problem. Please try logging in again.`,
    icon: "🔧",
  },
  ERROR_IMAGE: {
    title: "Image Upload Failed",
    msg: "Sorry, we couldn't upload the image. Please remove it and try again.",
  },
  ERROR_DEALER_NOT_FOUND: { title: "Dealer not found" },
  ERROR_DXF: { title: "Error Generating DXF" },
  CONFIRM_DELETE: {
    title: "About to Delete {name}",
    msg: "Are you sure?",
  },
  CONFIRM_DELETE_NAME: {
    title: "About to Delete {name}",
    msg: "Are you sure you want to remove {name}?",
  },
  DEV_MODE: {
    title: "DEV MODE ON",
    msg: "Now you know Kung-Fu!",
    icon: "😎",
  },
  PROJECTS_LOADING: {
    title: "Fetching projects",
    msg: "Hang tight while we get your projects!",
  },
  DEALERS_LOADING: {
    title: "Fetching dealers",
    msg: "Hang tight while we get your dealers!",
  },
  ORDERS_LOADING: {
    title: "Fetching orders",
    msg: "Hang tight while we get your orders!",
  },
  PROJECT_DATA_NOT_FOUND: {
    title: "No Projects Were Found",
    msg: "Try a different filter.",
  },
  DEALER_DATA_NOT_FOUND: {
    title: "No Dealers Were Found",
    msg: "Import a new Dealer to get started.",
  },
  ERROR_IMPORT_DEALER: {
    title: "Missing Data",
    msg: "Please input Latham Rewards ID.",
  },
  ERROR_REWARDS_ID_EXISTS: {
    title: "Rewards ID Exists",
    msg: "This Rewards ID already exists in our dealers list. Please use a different Rewards ID.",
  },
  ORDER_DATA_NOT_FOUND: {
    title: "No Orders Were Found",
    msg: "Create a new Order to get started.",
  },
  SUCCESS_NO_EMPLOYEES_ASSIGNED: {
    title: "Done!",
    msg: "Note: There are no users set up for the account this project has been assigned to.",
  },
};

export const ORDER_MSG = {
  ORDER_ARCHIVE: "Archive Order",
  ORDER_UNARCHIVE: "Unarchive Order",
  QUOTE_ARCHIVE: "Archive Quote",
  QUOTE_UNARCHIVE: "Unarchive Quote",
  ARCHIVE: "Archive",
  UNARCHIVE: "Unarchive",
  DELETE_ORDER: "Delete Order",
  CANCEL_QUOTE: "Cancel Quote",
  DELETE: "Delete",
};

/**
 * Helper function to translate USER_MSG objects by key
 * @param t - Translation function from useT()
 * @param key - USER_MSG key (e.g., "SUCCESS_TOS", "ERROR_GENERIC")
 * @param options - Optional interpolation options for messages with placeholders
 * @returns Translated USER_MSG object
 */
export function getTranslatedUserMsg(
  t: any,
  key: keyof typeof USER_MSG,
  options?: { name?: string },
): UserMsg {
  const msg = USER_MSG[key];
  if (!msg || !("title" in msg)) return { title: "", msg: "" };

  const translationKeyMap: Record<
    keyof typeof USER_MSG,
    { title: string; msg: string }
  > = {
    SUCCESS_TOS: { title: "userMsg.successTos.title", msg: "userMsg.successTos.msg" },
    ERROR_INVALID_BUYING_GROUP: {
      title: "userMsg.errorInvalidBuyingGroup.title",
      msg: "userMsg.errorInvalidBuyingGroup.msg",
    },
    PROJECTS_NOT_FOUND: {
      title: "userMsg.projectsNotFound.title",
      msg: "userMsg.projectsNotFound.msg",
    },
    EMPLOYEES_NOT_FOUND: {
      title: "userMsg.employeesNotFound.title",
      msg: "userMsg.employeesNotFound.msg",
    },
    GENERIC_LOADING: {
      title: "userMsg.genericLoading.title",
      msg: "userMsg.genericLoading.msg",
    },
    EMPLOYEES_LOADING: {
      title: "userMsg.employeesLoading.title",
      msg: "userMsg.employeesLoading.msg",
    },
    DEALER_NOT_FOUND: {
      title: "userMsg.dealerNotFound.title",
      msg: "userMsg.dealerNotFound.msg",
    },
    DEALER_LOADING: {
      title: "userMsg.dealerLoading.title",
      msg: "userMsg.dealerLoading.msg",
    },
    SUCCESS_GENERIC: {
      title: "userMsg.successGeneric.title",
      msg: "userMsg.successGeneric.msg",
    },
    SUCCESS_IMAGE: {
      title: "userMsg.successImage.title",
      msg: "userMsg.successImage.msg",
    },
    SUCCESS_ORDER_CREATE: {
      title: "userMsg.successOrderCreate.title",
      msg: "userMsg.successOrderCreate.msg",
    },
    SUCCESS_ORDER_DELETE: {
      title: "userMsg.successOrderDelete.title",
      msg: "userMsg.successOrderDelete.msg",
    },
    SUCCESS_ORDER_SAVE: {
      title: "userMsg.successOrderSave.title",
      msg: "userMsg.successOrderSave.msg",
    },
    SUCCESS_ORDER_ARCHIVE: {
      title: "userMsg.successOrderArchive.title",
      msg: "userMsg.successOrderArchive.msg",
    },
    SUCCESS_ORDER_UNARCHIVE: {
      title: "userMsg.successOrderUnarchive.title",
      msg: "userMsg.successOrderUnarchive.msg",
    },
    SUCCESS_QUOTE_CREATE: {
      title: "userMsg.successQuoteCreate.title",
      msg: "userMsg.successQuoteCreate.msg",
    },
    SUCCESS_QUOTE_SAVE: {
      title: "userMsg.successQuoteSave.title",
      msg: "userMsg.successQuoteSave.msg",
    },
    SUCCESS_SCAN_REJECT: {
      title: "userMsg.successScanReject.title",
      msg: "userMsg.successScanReject.msg",
    },
    SUCCESS_SCAN_UNREJECT: {
      title: "userMsg.successScanUnreject.title",
      msg: "userMsg.successScanUnreject.msg",
    },
    SUCCESS_QUOTE_REVERT: {
      title: "userMsg.successQuoteRevert.title",
      msg: "userMsg.successQuoteRevert.msg",
    },
    SUCCESS_QUOTE_SUBMIT: {
      title: "userMsg.successQuoteSubmit.title",
      msg: "userMsg.successQuoteSubmit.msg",
    },
    SUCCESS_QUOTE_CANCEL: {
      title: "userMsg.successQuoteCancel.title",
      msg: "userMsg.successQuoteCancel.msg",
    },
    SUCCESS_QUOTE_ARCHIVE: {
      title: "userMsg.successQuoteArchive.title",
      msg: "userMsg.successQuoteArchive.msg",
    },
    SUCCESS_QUOTE_UNARCHIVE: {
      title: "userMsg.successQuoteUnarchive.title",
      msg: "userMsg.successQuoteUnarchive.msg",
    },
    SUCCESS_ORDER_SUBMIT: {
      title: "userMsg.successOrderSubmit.title",
      msg: "userMsg.successOrderSubmit.msg",
    },
    ERROR_SCAN_REJECT_EMPTY_REASON: {
      title: "userMsg.errorScanRejectEmptyReason.title",
      msg: "userMsg.errorScanRejectEmptyReason.msg",
    },
    ERROR_ORDER_ID_MISSING: {
      title: "userMsg.errorOrderIdMissing.title",
      msg: "userMsg.errorOrderIdMissing.msg",
    },
    ERROR_SAVING_ORDER: {
      title: "userMsg.errorSavingOrder.title",
      msg: "userMsg.errorSavingOrder.msg",
    },
    ERROR_CREATING_ORDER: {
      title: "userMsg.errorCreatingOrder.title",
      msg: "userMsg.errorCreatingOrder.msg",
    },
    ERROR_NEW_QUOTE: {
      title: "userMsg.errorNewQuote.title",
      msg: "userMsg.errorNewQuote.msg",
    },
    ERROR_DELETING_ORDER: {
      title: "userMsg.errorDeletingOrder.title",
      msg: "userMsg.errorDeletingOrder.msg",
    },
    ERROR_DELETING_QUOTE: {
      title: "userMsg.errorDeletingQuote.title",
      msg: "userMsg.errorDeletingQuote.msg",
    },
    ERROR_SAVING_PROJECT: {
      title: "userMsg.errorSavingProject.title",
      msg: "userMsg.errorSavingProject.msg",
    },
    ERROR_CREATING_PROJECT: {
      title: "userMsg.errorCreatingProject.title",
      msg: "userMsg.errorCreatingProject.msg",
    },
    ERROR_DELETING_PROJECT: {
      title: "userMsg.errorDeletingProject.title",
      msg: "userMsg.errorDeletingProject.msg",
    },
    ERROR_ORDER_DATA: {
      title: "userMsg.errorOrderData.title",
      msg: "userMsg.errorOrderData.msg",
    },
    ERROR_MEASUREMENT_DATA: {
      title: "userMsg.errorMeasurementData.title",
      msg: "userMsg.errorMeasurementData.msg",
    },
    ERROR_GENERIC: {
      title: "userMsg.errorGeneric.title",
      msg: "userMsg.errorGeneric.msg",
    },
    ERROR_INVALID: {
      title: "userMsg.errorInvalid.title",
      msg: "userMsg.errorInvalid.msg",
    },
    ERROR_EMAIL_CONFLICTS: {
      title: "userMsg.errorEmailConflicts.title",
      msg: "userMsg.errorEmailConflicts.msg",
    },
    ERROR_PROJECT_SCAN_REJECTED: {
      title: "userMsg.errorProjectScanRejected.title",
      msg: "userMsg.errorProjectScanRejected.msg",
    },
    ERROR_INVALID_DATA: {
      title: "userMsg.errorInvalidData.title",
      msg: "userMsg.errorInvalidData.msg",
    },
    ERROR_INCOMPLETE_PROJECT: {
      title: "userMsg.errorIncompleteProject.title",
      msg: "userMsg.errorIncompleteProject.msg",
    },
    ERROR_PURCHASE_PARTNER_DEALER_NOT_FOUND: {
      title: "userMsg.errorPurchasePartnerDealerNotFound.title",
      msg: "userMsg.errorPurchasePartnerDealerNotFound.msg",
    },
    ERROR_SAVING_PURCHASE_PARTNER: {
      title: "userMsg.errorSavingPurchasePartner.title",
      msg: "userMsg.errorSavingPurchasePartner.msg",
    },
    ERROR_QUOTE_ORDER_DISABLED_PURCHASE_PARTNER: {
      title: "userMsg.errorQuoteOrderDisabledPurchasePartner.title",
      msg: "userMsg.errorQuoteOrderDisabledPurchasePartner.msg",
    },
    ERROR_UNAUTH_ROUTE: {
      title: "userMsg.errorUnauthRoute.title",
      msg: "userMsg.errorUnauthRoute.msg",
    },
    ERROR_UNAUTH_LOGIN: {
      title: "userMsg.errorUnauthLogin.title",
      msg: "userMsg.errorUnauthLogin.msg",
    },
    ERROR_PASSWORD_CHANGE_REQUIRED: {
      title: "userMsg.errorPasswordChangeRequired.title",
      msg: "userMsg.errorPasswordChangeRequired.msg",
    },
    ERROR_PASSWORD_RESET_REQUIRED: {
      title: "userMsg.errorPasswordResetRequired.title",
      msg: "userMsg.errorPasswordResetRequired.msg",
    },
    ERROR_UNAUTHORIZED_ACCESS: {
      title: "userMsg.errorUnauthorizedAccess.title",
      msg: "userMsg.errorUnauthorizedAccess.msg",
    },
    ERROR_USER_NOT_FOUND: {
      title: "userMsg.errorUserNotFound.title",
      msg: "userMsg.errorUserNotFound.msg",
    },
    ERROR_SERVER: {
      title: "userMsg.errorServer.title",
      msg: "userMsg.errorServer.msg",
    },
    ERROR_IMAGE: { title: "userMsg.errorImage.title", msg: "userMsg.errorImage.msg" },
    ERROR_DEALER_NOT_FOUND: { title: "userMsg.errorDealerNotFound.title", msg: "" },
    ERROR_DXF: { title: "userMsg.errorDxf.title", msg: "" },
    CONFIRM_DELETE: {
      title: "userMsg.confirmDelete.title",
      msg: "userMsg.confirmDelete.msg",
    },
    CONFIRM_DELETE_NAME: {
      title: "userMsg.confirmDeleteName.title",
      msg: "userMsg.confirmDeleteName.msg",
    },
    DEV_MODE: { title: "userMsg.devMode.title", msg: "userMsg.devMode.msg" },
    PROJECTS_LOADING: {
      title: "userMsg.projectsLoading.title",
      msg: "userMsg.projectsLoading.msg",
    },
    DEALERS_LOADING: {
      title: "userMsg.dealersLoading.title",
      msg: "userMsg.dealersLoading.msg",
    },
    ORDERS_LOADING: {
      title: "userMsg.ordersLoading.title",
      msg: "userMsg.ordersLoading.msg",
    },
    PROJECT_DATA_NOT_FOUND: {
      title: "userMsg.projectDataNotFound.title",
      msg: "userMsg.projectDataNotFound.msg",
    },
    DEALER_DATA_NOT_FOUND: {
      title: "userMsg.dealerDataNotFound.title",
      msg: "userMsg.dealerDataNotFound.msg",
    },
    ERROR_IMPORT_DEALER: {
      title: "userMsg.errorImportDealer.title",
      msg: "userMsg.errorImportDealer.msg",
    },
    ERROR_REWARDS_ID_EXISTS: {
      title: "userMsg.errorRewardsIdExists.title",
      msg: "userMsg.errorRewardsIdExists.msg",
    },
    ORDER_DATA_NOT_FOUND: {
      title: "userMsg.orderDataNotFound.title",
      msg: "userMsg.orderDataNotFound.msg",
    },
    SUCCESS_NO_EMPLOYEES_ASSIGNED: {
      title: "userMsg.successNoEmployeesAssigned.title",
      msg: "userMsg.successNoEmployeesAssigned.msg",
    },
  };

  const translationKeys = translationKeyMap[key];
  if (!translationKeys) return msg as UserMsg;

  const result: UserMsg = {
    title: translationKeys.title
      ? String(t(translationKeys.title, msg.title, options))
      : msg.title,
    msg:
      translationKeys.msg && "msg" in msg
        ? String(t(translationKeys.msg, msg.msg, options))
        : "msg" in msg
          ? msg.msg
          : "",
  };

  if ("icon" in msg && msg.icon) {
    result.icon = msg.icon;
  }

  return result;
}
